import { CHCHero } from "./hero.component.js";
customElements.define("chc-hero", CHCHero);
export {
  CHCHero
};
//# sourceMappingURL=hero.js.map
